import type { I18nStrings } from './types.js';

export const en: I18nStrings = {
  chat_placeholder: 'Type a message...',
  chat_send: 'Send',
  my_submitted_issues: 'My Submitted Issues',
  pick_topic: 'Pick a topic or type a question below',
  welcome_default:
    'Hi! I can answer questions, help you report issues, or request new features. How can I help?',
  privacy_notice:
    'Messages are processed to help resolve your issue. We never store personal information.',
  feedback_yes: 'Yes, this is fixed!',
  feedback_no: 'No, still broken',
  feedback_thanks: 'Thanks for confirming!',
  feedback_reopened: "We're sorry this isn't fixed yet \u2014 we've reopened it.",
  empty_issues: 'No issues reported \u2014 use Chat to report something.',
  error_fallback:
    "We're having trouble connecting right now, but we've logged your message.",
  attachment_add: 'Attach screenshot or file',
  attachment_uploading: 'Uploading...',
  updates_banner: 'Since your last visit',
  close: 'Close',
  typing: 'Assistant is typing',
  new_updates: 'support updates',
};
